var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"text-center"},[_c('h1',{staticClass:"mb-4"},[_vm._v("loading")]),_c('h1',[_c('i',{staticClass:"fa fa-spinner fa-pulse fa-lg fa-fw"})])])}
var staticRenderFns = []

export { render, staticRenderFns }